export default {
  beforeMount(el, binding) {
    const ourClickEventHandler = (e) => {
      if (!el.contains(e.target) && el !== e.target) {
        binding.value(e)
      }
    }

    el._clickOutsideEvent = ourClickEventHandler
    document.addEventListener('click', ourClickEventHandler)
  },

  unmounted(el) {
    document.removeEventListener('click', el._clickOutsideEvent)
  },
}
